import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeSpaces',
    standalone: false
})
export class RemoveSpacesPipe implements PipeTransform {
  transform(value: string, _args: string[]): any {
    if (!value) {
      return value
    }

    return value.replace(/\s+/g, '');
  }
}
